import React, { PureComponent } from 'react';
import { I18n } from 'aws-amplify';
import styled from 'styled-components';
import {
    Table,
    Icon
} from 'antd';

const Btns = styled.p`
width: 50px;
displa: block;
    a {
        margin-left: 10px;
    }
`


class tableReference extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }

    getSector = (sectorId) => {
        const items = this.props.sectorsFlat && this.props.sectorsFlat.filter((item) => item.code == sectorId);


        if (items && items.length) {
            return items[0].label;
        }
        else {
            return {};
        }

    }

    render() {
        const columns = [
            {
                title: I18n.get("Nome"),
                dataIndex: 'name',
                key: 'name'
            },
            {
                title: I18n.get("E-mail"),
                dataIndex: 'email',
                key: 'email'
            },
            {
                title: I18n.get("Linkedin"),
                dataIndex: 'linkedin',
                key: 'linkedin'
            },
            {
                title: I18n.get("Ano"),
                dataIndex: 'year',
                key: 'year'
            },
            {
                title: I18n.get("Relação"),
                dataIndex: 'relation',
                key: 'relation'
            },
            {
                title: '',
                dataIndex: 'action',
                key: 'item',
                render: (text, record) => {
                    let data = {
                        id: record.item.id,
                        // partnerId: this.props.match.params.partnerId,
                    }

                    return (<Btns>
                        <a onClick={() => this.props.viewReference(record.item)}>
                            <Icon type="eye" theme="filled" />
                        </a>
                        {/* <a onClick={() => this.props.delReference(data)}>
                            <Icon type="delete" theme="filled" />
                        </a>
                        <a onClick={() => this.showEditReference(record.item)}>
                            <Icon type="edit" theme="filled" />
                        </a> */}
                    </Btns>)
                }
            },
        ]

        let dataTable = this.props.data && this.props.data.map((item, index) => {
            return {
                key: index,
                name: item.name,
                email: item.email,
                linkedin: item.linkedInUrl,
                year: item.year,
                relation: item.relation && item.relation.label,
                item: item
            }
        });

        return (
            <Table
                columns={columns}
                dataSource={dataTable}
                locale={{ emptyText: I18n.get('Sem informação') }}
                scroll={{ x: 640 }}
            />
        );
    }
}

export default tableReference;
